export default __webpack_public_path__ + "static/media/logo_title.99110cce.svg";